module.exports = "images/doc-program-add.63cd42388e79d96f4e4fbb27fdd4bca3.png";